import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { checkFccId } from 'actions/model';

class FccLink extends Component {
  componentDidMount() {
    const { checkFccId, fccId } = this.props;
    checkFccId(fccId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fccId !== nextProps.fccId) {
      this.props.checkFccId(nextProps.fccId);
    }
  }

  render() {
    const { model, fccId } = this.props;
    const modelFccGcode = model ? model.gcode : null;

    // show fcc id as is (not as link)
    if (modelFccGcode === null || modelFccGcode === false) return fccId;

    // show link to fcc tool
    // (generic search at fcc.gov website)
    return (
      <Link to={`/tools/fccid/${fccId}`} target="_blank">
        {fccId}
      </Link>
    );
  }
}

function mapStateToProps({ model }) {
  return { model };
}

export default connect(
  mapStateToProps,
  { checkFccId }
)(FccLink);



// WEBPACK FOOTER //
// ./src/components/FccLink.js